import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';
import YachtDescriptionBlock from './YachtDescriptionBlock';

const YachtDescriptionBlockWithLink = ({ blockWithLink, renderLink, professionalsMap }) => {
  const blockWithLinkSplit = blockWithLink.split('}}');
  const professionalId = blockWithLinkSplit[0];
  const restOfTheBlock = blockWithLinkSplit.slice(1, blockWithLinkSplit.length).join('}}');
  const professionalData = professionalsMap[professionalId];

  if (!professionalData) return <YachtDescriptionBlock block={restOfTheBlock} />;

  return (
    <>
      {!renderLink && professionalData.name}
      {renderLink && (
        <Link href={`/profiles/${professionalData.slug}`}>{professionalData.name}</Link>
      )}
      <YachtDescriptionBlock block={restOfTheBlock} />
    </>
  );
};

YachtDescriptionBlockWithLink.propTypes = {
  blockWithLink: PropTypes.string.isRequired,
  renderLink: PropTypes.bool.isRequired,
  professionalsMap: PropTypes.object.isRequired
};

export default YachtDescriptionBlockWithLink;
